import React, { useState } from "react";
import { useField, useFormikContext } from "formik";
import { Form, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import SummaryItem from "../components/SummaryItem/SummaryItem";
import _ from "lodash";
import Modal from "../../common/Modal/Modal";

export default function RadiobuttonsField(props) {
  const { label, options, onChange, stepToExclude, validationSchema, ...rest } =
    props;
  const { summaryMode } = rest;
  const [field, meta, helper] = useField(props);
  const [fieldPass, setFieldPass] = useState(false);

  const { values, setFieldValue } = useFormikContext();
  const { setValue } = helper;
  const { t } = useTranslation();
  const isRequired = validationSchema?.fields[field.name]?._exclusive?.required;

  let labelFormatted = label;
  if (summaryMode) {
    labelFormatted = rest.summaryLabel ? rest.summaryLabel : label;
  }
  const selectedValue = _.head(options.filter((i) => i.value === field.value));
  const valueToRender = selectedValue ? selectedValue.label : "";
  function _onChange(e) {
    if (onChange) {
      onChange(e.target.value, values, setFieldValue);
    }
    setValue(e.target.value);
  }
  function optionToExclude(option) {
    if (stepToExclude) {
      let stepToExcludeVariable = stepToExclude();
      return !stepToExcludeVariable.includes(option.value);
    } else return true;
  }
  return (
    <Form.Group
      className={
        meta.touched && meta.error ? "radio-button is-invalid" : "radio-button"
      }
    >
      {!summaryMode ? (
        <>
          {labelFormatted && <legend className={"paragraph-small-fs9"}>
            {labelFormatted}
            {props.message ? (
              <button
                type="button"
                className="form-info-button"
                aria-label={t("aria.form.info.button")}
                aria-haspopup="dialog"
                aria-controls={field.name + "-info-modal"}
                onClick={() => {
                  setFieldPass(true);
                }}
              >
                {" "}
                <span className="form-icon-info" aria-hidden="true"></span>
              </button>
            ) : null}
          </legend>}
          <Row>
            {(options || [])
              .filter((option) => optionToExclude(option))
              .map((option, index) => {
                const { grid: gridProps } = option;
                return (
                  <Col
                    {...gridProps}
                    key={`option-${index}`}
                    className="form-check abc-radio"
                  >
                    <input
                      type="radio"
                      className="form-check-input"
                      name={field.name}
                      id={
                        option?.label?.props?.i18nKey
                          ? t(option?.label?.props?.i18nKey)
                          : option?.label
                      }
                      value={option.value}
                      checked={meta.value === option.value}
                      onChange={_onChange}
                      required={isRequired}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={
                        option?.label?.props?.i18nKey
                          ? t(option?.label?.props?.i18nKey)
                          : option?.label
                      }
                    >
                      {option.label}
                    </label>
                  </Col>
                );
              })}
          </Row>
          {meta.touched && meta.error && (
            <span
              className="form-error-text paragraph-small-form"
              role="alert"
              id={field.name + "-error"}
            >
              {meta.error}
            </span>
          )}
        </>
      ) : (
          <>
            {labelFormatted && (
              <span className="paragraph-small-fs9">{labelFormatted}</span>
            )}
            <SummaryItem value={valueToRender} error={meta.error} />
          </>
      )}
      {fieldPass ? (
        <Modal
          show={fieldPass}
          onClose={() => setFieldPass(false)}
          description={t(props.messageText)}
          type="button"
          onFirstClick={() => setFieldPass(false)}
          linkTitle={t("common.hoCapito")}
        />
      ) : null}
    </Form.Group>
  );
}
